import { PhoneInputStrings, PhoneNumberValidationStrings } from './index';
import { translateFn } from '../../../utils/translator.helper';

export const getPhoneInputDefaultStrings = (): PhoneInputStrings => ({
  numberPlaceholder: translateFn('Insert number here'),
  phoneCodeLabel: translateFn('Country code'),
  label: translateFn('Phone number'),
  emptyCodeValuePlaceholder: translateFn('Select country code first'),
  noSearchResultsString: translateFn('No results'),
  searchPlaceholderString: translateFn('Search'),
});

export const getPhoneInputValidationDefaultStrings = (): Required<PhoneNumberValidationStrings> => ({
  mandatoryErrorText: translateFn('The phone number and country code fields are required.'),
  invalidInputValueErrorText: translateFn('Phone number must be between 3 and 14 digits.'),
  invalidPhoneErrorText: translateFn('Country code and phone number combined must not exceed 15 characters.'),
});
